import { ru } from 'date-fns/locale';

export const dateRu = {
  ...ru,
  localize: {
    ...ru.localize,
    day: (i, opts) => ru.localize.day(i, { ...opts, width: 'short' }),
  },
};
